import React from 'react';
import { Chip } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { ValidationBadgeProps } from './types';
import './ValidationBadge.scss';

export const ValidationBadge: React.FC<ValidationBadgeProps> = ({
  validationResult,
  size = 'small',
}) => {
  // Handle null/undefined validation results
  if (!validationResult) {
    return null;
  }

  const { isValid, errors, warnings } = validationResult;

  // Don't show badge if no errors and no warnings
  if (isValid && warnings.length === 0) {
    return null;
  }

  // Show error badge if there are errors
  if (errors.length > 0) {
    const errorMessage = errors[0].message;

    return (
      <Chip
        icon={<ErrorOutlineIcon />}
        label={errorMessage}
        className={`validationBadge error ${size}`}
        size={size}
      />
    );
  }

  // Show warning badge if there are warnings (but no errors)
  if (warnings.length > 0) {
    const warningMessage = warnings[0].message;

    return (
      <Chip
        icon={<WarningAmberIcon />}
        label={warningMessage}
        className={`validationBadge warning ${size}`}
        size={size}
      />
    );
  }

  return null;
};
